import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { StepAttachments } from "../StepAttachments";
import { StepForm } from "./StepForm";

const pick = (s) => ({ title: s.title, description: s.description, agent_id: s.agent_id || "", agent_model: s.agent_model || "", needs_approval: !!s.needs_approval, run_mode: s.run_mode || "auto", context_step_ids: s.context_step_ids || [] });

// Edit a step that has not run yet (pending), or the step the workflow stopped on (paused / failed / waiting approval) — same form as the draft editor.
export function PendingStepEditor({ task, s, idx, onDone, onCancel, onAttach }) {
  const [v, setV] = useState(pick(s));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!v.title.trim() || !v.description.trim()) { toast.error("Judul dan deskripsi tidak boleh kosong"); return; }
    setBusy(true);
    const { title, description, needs_approval, run_mode, agent_id, agent_model, context_step_ids } = v;
    try { await api.put(`/tasks/${task.id}/steps/${s.id}`, { title: title.trim(), description: description.trim(), needs_approval, run_mode, agent_id: agent_id || null, agent_model: agent_model || "", context_step_ids }); toast.success("Langkah diperbarui"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal mengubah langkah"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 space-y-2 rounded-xl border border-[#2F6BFF]/30 bg-[#EEF3FF] p-3" data-testid="wf-pending-editor">
      <StepForm value={v} onChange={(p) => setV((x) => ({ ...x, ...p }))} steps={task.steps} index={idx} total={task.steps.length} idx={idx}
        attachments={<StepAttachments taskId={task.id} stepId={s.id} attachments={s.attachments || []} idx={idx} onChanged={onAttach} task={task} />} />
      <div className="flex gap-2"><button onClick={save} disabled={busy} className="btn-grad rounded-lg px-4 py-1.5 text-xs" data-testid="wf-pending-save">{busy ? "Menyimpan..." : "Simpan perubahan"}</button><button onClick={onCancel} className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-600" data-testid="wf-pending-cancel">Batal</button></div>
    </div>
  );
}
